import React, {FC, memo} from "react";
import {IDataGridColumnEditorString} from "../../../model";
import {Controller, useForm} from "react-hook-form";
import {TextField} from "@material-ui/core";
import {ClickAwayListener} from "@material-ui/core";
import Footer from "./footer";
import {validateRule} from "../../../../form/heplers";
import {useI18n} from "../../../../i18";

const EditorString: FC<{
  editor: IDataGridColumnEditorString,
  data: string,
  onClose: any,
  onSubmit: any
}> = ({editor, data, onClose, onSubmit}) => {
  const {t} = useI18n();
  const {handleSubmit, errors, control} = useForm({defaultValues: {data: data || ''}});
  return (
    <ClickAwayListener onClickAway={onClose}>
      <div className="grid-editor string">
        <form
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            as={
              <TextField
                fullWidth
                autoFocus
                error={Boolean(errors.data)}
                // @ts-ignore
                helperText={errors.data ? t(errors.data.message) : ''}
              />
            }
            name="data"
            control={control}
            rules={editor.required ? validateRule('required') : {}}
          />
          <Footer onClose={onClose}/>
        </form>
      </div>
    </ClickAwayListener>
  )
};

export default memo(EditorString)
